const CONSTANTS = {
  JulyDate: "2023-07-10",
  PercentageTooltipText: "The % +/- is related to last month compared to the previous month.",
  availableLinkTypes: [
    {label: "All DR", value: "all"},
    {label: "DR +70", value: "+70"},
  ],
  availableCampaignTypes: [
    {label: "All", value: null},
    {label: "Data Driven", value: "data_driven"},
    {label: "Reactive", value: "reactive"},
    {label: "White Paper", value: "white_paper"},
    {label: "Personal Branding", value: "personal_branding"},
    {label: "Other", value: "other"},
  ]
};

export default CONSTANTS;